<!--
 * @Author: zyy
 * @Date: 2023-07-18 14:12:55
 * @LastEditTime: 2023-07-18 15:06:31
 * @FilePath: /tjzhsq-admin-dnk/src/views/platform/complaint/modules/cancel.vue
 * @Description: yahu~
 * 
-->
<template>
    <div>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
            destroy-on-close centered>
            <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
                <a-form-model-item label="关闭原因" prop='staff'>
                    <a-textarea v-model="modal.subData.cancelReason"></a-textarea>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import complaintListService from "@/io/complaint/complaintList.js";
import CommunityService from "@/io/community.js";

export default {
    emits: ['submit'],
    data() {
        return {
            modal: {
                closeType: true,
                title: '关闭工单',
                show: false,
                loading: false,
                // 0新增，1编辑
                type: 0,
                subData: {
                    cancelReason: null
                },
            },
            form: {},
            rules: {},
            info: {}

        }
    },
    methods: {
        open(data) {
            this.modal.show = true
            this.info = data
        },
        // 提交
        confirmModal() {
            this.$beforeFormSubmit(this.$refs.form, async () => {
                const res = await complaintListService.cancel(this.info.id, this.modal.subData.cancelReason)
                this.$afterFormSubmit("修改成功", () => {
                    this.modal.closeType = false
                    this.modal.show = false
                    this.modal.loading = false
                    this.$emit('submit')

                });
            });
        },
    }
}

</script>

<style scoped lang="scss"></style>
